import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-PhoneCall" */'@modals/partials/Phonecall'));
